import React from 'react';

import {
  Modal
} from '@salesforce/design-system-react';

function useToggle(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);
  const toggle = React.useCallback(() => {
    setValue((v) => !v);
  }, []);
  return [value, toggle];
}

const PersonaInstructions = (props) => {
  const [isOpen, toggleIsOpen] = useToggle();

  return (
    <React.Fragment>
        <div 
          style={{ fontSize: '.8rem'}}>
            What are the <span style={{ color: '#1B96FF', fontWeight: '600', cursor: 'pointer'}} onClick={toggleIsOpen}>Personas?</span>
        </div>
        <Modal
          isOpen={isOpen}
          onRequestClose={toggleIsOpen}
          heading="What are the Personas?"
        >
          <section className="slds-p-around_medium">
            <div
              style={{ marginTop: '5px', marginBottom: '5px', fontSize: '1rem' }}
              className="slds-text-body_large"
            >
              Now let's define our story personas! We'll start with the Hero
              (Persona 1) who is always your customer's customer and then using
              the Business Challenge you developed in Step 1, determine which
              additonal personas are most critical to the success of your
              Business Challenge.
            </div>
            <div
              style={{ marginTop: '5px', marginBottom: '5px', fontSize: '1rem'  }}
              className="slds-text-body_large"
            >
              The additional personas are typically internal employees or
              partners of your customer. In order to determine the best personas
              to select, discuss the lifecycle of your Hero and their engagement
              with your customer. We recommend no more than 4 personas.
            </div>
          </section>
        </Modal>
    </React.Fragment>
  );
};

export default PersonaInstructions;
